'use client';

import Script from 'next/script';
import { useEffect, useState } from 'react';
import { getStoredCookieConsent } from '@/components/CookieBanner';

export default function GoogleAnalytics() {
  const id = process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID?.trim();
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    if (!id) {
      return;
    }
    const sync = () => setEnabled(getStoredCookieConsent() === 'accepted');
    sync();
    window.addEventListener('aos-cookie-consent-change', sync);
    return () => window.removeEventListener('aos-cookie-consent-change', sync);
  }, [id]);

  if (!id || !enabled) {
    return null;
  }

  return (
    <>
      <Script
        src={`https://www.googletagmanager.com/gtag/js?id=${id}`}
        strategy="afterInteractive"
      />
      <Script id="aos-ga-init" strategy="afterInteractive">
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', '${id}', { anonymize_ip: true });
        `}
      </Script>
    </>
  );
}
